<template>
    <div class="rightBottom">
        <!-- <hd-tit :title="'价格趋势'" :ENtitle="'Price  trend'"></hd-tit> -->
        <div class="trendClass">
            <div class="filterBox"></div>
            <p class="title">活动统计</p>
            <div id="rightline" style="width: 420px; height: 280px"></div>
        </div>
    </div>
</template>

<script>
// import hdTit from './modulTitle';
import echarts from 'echarts';
export default {
    props: {
        listData: {
            type: Array,
            default: () => {
                return [];
            }
        },
        bulleMessage: {
            type: String,
            default: ''
        },
        min: {
            type: String,
            default: ''
        },
        max: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            myChart: null
        };
    },
    computed: {},
    created() {},
    mounted() {
        this.myChart = echarts.init(document.getElementById('rightline'), null, {
            devicePixelRatio: 2
        });
    },
    watch: {
        listData(nVal) {
            const m = nVal.map((item) => {
                return item.period;
            });

            const d = nVal.map((item) => {
                return item.total;
            });

            this.setOption(m, d);
        }
    },
    methods: {
        setOption(m, d) {
            var option = {
                grid: {
                    left: '15%',
                    right: '10%',
                    bottom: '20%',
                    top: '20%'
                },
                tooltip: {
                    trigger: 'axis',
                    formatter: function (params) {
                        return params[0].name + ': ' + params[0].value;
                    }
                },
                xAxis: {
                    axisLabel: {
                        // interval: 6,
                        textStyle: {
                            color: '#ffffff',
                            fontSize: 14,
                            fontFamily: 'Microsoft YaHei'
                        }
                    },
                    axisLine: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    data: m
                },
                yAxis: {
                    splitLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    }
                },
                series: [
                    {
                        name: 'hill',
                        type: 'pictorialBar',
                        barCategoryGap: '-80%',
                        symbol: 'path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z',
                        label: {
                            show: true,
                            position: 'top',
                            distance: 2,
                            fontSize: 12,
                            formatter: function (params) {
                                return d[params.dataIndex];
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: function (params) {
                                    const colorList = [
                                        'rgba(131,249,103, 0.7)',
                                        'rgba(251,254,39,0.7)',
                                        'rgba(254,80,80,0.7)',
                                        'rgba(29,183,229, 0.7)',
                                        'rgba(243,151,47, 0.7)',
                                        'rgba(47,240,210, 0.7)'
                                    ];

                                    return colorList[params.dataIndex];
                                }
                            },
                            emphasis: {
                                opacity: 1
                            }
                        },
                        data: d,
                        z: 10
                    }
                ]
            };

            this.myChart.setOption(option, true);
        }
    },
    components: {
        // hdTit
    }
};
</script>
<style scoped lang="scss">
.rightBottom {
    position: absolute;
    bottom: 20px;
    right: 50px;
    .trendClass {
        position: relative;
        background: url(../../assets/img/card.png) no-repeat;
        background-position: 0 0;
        background-size: 100% 100%;
        width: 470px;
        height: 280px;
        margin-top: 10px;
        padding-top: 30px;
        box-sizing: border-box;
        padding: 18px;
    }
    .filterBox {
        background: rgba($color: #000000, $alpha: 0.4);
        position: absolute;
        top: 0;
        bottom: 0;
        width: 100%;
        z-index: -1;
        -webkit-filter: blur(9px);
        -moz-filter: blur(9px);
        -o-filter: blur(9px);
        -ms-filter: blur(9px);
        filter: blur(30px);
    }
}
.title {
    position: absolute;
    background: rgba($color: #00c2ff, $alpha: 0.6);
    color: #ffffff;
    font-weight: bold;
    font-size: 20px;
    padding: 5px 10px;
    display: inline-block;
}
</style>
